import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/shared/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors',
  {
    variants: {
      variant: {
        brand: 'border-transparent bg-brand-100 text-brand-700',
        mint: 'border-transparent bg-mint-100 text-mint-600',
        amber: 'border-transparent bg-amber-100 text-amber-600',
        coral: 'border-transparent bg-coral-100 text-coral-600',
        success: 'border-transparent bg-mint-100 text-mint-600',
        neutral: 'border-surface-200 bg-surface-100 text-ink-500',
      },
    },
    defaultVariants: {
      variant: 'neutral',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps): JSX.Element {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}
